import {defineStore} from "pinia";
import api from "@/plugins/axios"

export const useTgChannelsStore = defineStore('tg-channels', {
    state: () => ({
        items: [],
        item: {}
    }),
    actions: {
        async getList() {
            try {
                const {data} = await api.get(`tg-channels`);
                this.items = data;
            } catch (error) {
                console.error(error);
            }
        },
        async getById(id) {
            try {
                const {data} = await api.get(`tg-channels/${id}`);
                this.item = data
            } catch (error) {
                console.error('Error fetching user details:', error);
            }
        },
        async update(id, data) {
            try {
                await api.put(`tg-channels/${id}/projects`, {
                    projectIds: data.projectIds
                });
            } catch (error) {
                console.error('Error updating user:', error);
                throw error;
            }
        }
    }
})
